import { createUseStyles } from 'react-jss'

export default createUseStyles({
  baseActionButton: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  pill: {
    alignItems: 'center',
    backgroundColor: 'var(--action-button__color) !important',
    borderRadius: '20px',
    border: 'none',
    boxShadow: 'var(--action-button__box__shadow) !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    '&:not(:last-child)': { marginRight: 20 },
    padding: '10px 20px',
    width: 'auto'
  },
  default: {
    border: 'none',
    backgroundColor: 'var(--action-button__color) !important',
    borderRadius: 20,
    cursor: 'pointer',
    flex: '1 0 70%',
    display: 'flex',
    opacity: 1,
    padding: '0 !important',
    '&:not(:last-child)': { marginRight: '40px' },
    minWidth: '200px'
  },
  wrapperDefault: {
    alignItems: 'center',
    appearance: 'none',
    backgroundColor: 'var(--action-button__color)',
    borderRadius: 20,
    boxShadow: 'var(--action-button__box__shadow)',
    color: 'var(--chat-bubble__text__color)',
    display: 'flex',
    flex: '1 0 100%',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    padding: '.75em',
    position: 'relative',
    whiteSpace: 'pre-line',
    width: 'inherit',
    wordBreak: 'break-word',
    '& div svg': {
      marginBottom: '5px !important'
    }
  },
  wrapperPill: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  }
})
